import api from './api';

/**
 * 🎫 LicenseService - Service para validação de licenças
 * 
 * Features:
 * - Validação em tempo real
 * - Verificação de email
 * - Cadastro com licença
 */
class LicenseService {
  
  /**
   * ✅ Validar licença em tempo real
   */
  static async validateLicense(licenseCode) {
    try {
      console.log(`🔍 Validando licença: ${licenseCode}`);
      
      const response = await api.post('/api/license/validate', {
        code: licenseCode
      });
      
      return {
        success: response.data.success,
        message: response.data.message,
        valid: response.data.valid,
        canRegister: response.data.canRegister
      };
      
    } catch (error) {
      console.error('❌ Erro ao validar licença:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao validar licença',
        valid: false,
        canRegister: false
      };
    }
  }
  
  /**
   * 🔍 Verificar se email já existe
   */
  static async checkEmailExists(email) {
    try {
      console.log(`🔍 Verificando email: ${email}`);
      
      const response = await api.post('/api/register/check-email', {
        email: email
      });
      
      return {
        success: response.data.success,
        message: response.data.message,
        exists: response.data.exists
      };
      
    } catch (error) {
      console.error('❌ Erro ao verificar email:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao verificar email',
        exists: false
      };
    }
  }
  
  /**
   * 🎯 Cadastrar usuário com licença
   */
  static async registerUser(userData, licenseCode) {
    try {
      console.log(`🎯 Cadastrando usuário: ${userData.email} com licença: ${licenseCode}`);
      
      const response = await api.post('/api/register/user', {
        name: userData.name,
        email: userData.email,
        password: userData.password,
        phone: userData.phone,
        cpf: userData.cpf,
        licenseCode: licenseCode
      });
      
      return {
        success: response.data.success,
        message: response.data.message,
        user: response.data.user,
        plan: response.data.plan
      };
      
    } catch (error) {
      console.error('❌ Erro ao cadastrar usuário:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao cadastrar usuário',
        user: null,
        plan: null
      };
    }
  }
  
  /**
   * 📊 Obter estatísticas de licenças
   */
  static async getLicenseStats() {
    try {
      console.log('📊 Buscando estatísticas das licenças');
      
      const response = await api.get('/api/license/stats');
      
      return {
        success: response.data.success,
        message: response.data.message,
        data: response.data.data
      };
      
    } catch (error) {
      console.error('❌ Erro ao buscar estatísticas:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao buscar estatísticas',
        data: null
      };
    }
  }
  
  /**
   * 🧪 Testar fluxo de cadastro
   */
  static async testRegistrationFlow() {
    try {
      console.log('🧪 Testando fluxo de cadastro');
      
      const response = await api.get('/api/register/test-flow');
      
      return {
        success: response.data.success,
        message: response.data.message,
        testData: response.data.testData
      };
      
    } catch (error) {
      console.error('❌ Erro no teste do fluxo:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro no teste do fluxo',
        testData: null
      };
    }
  }

  /**
   * ✅ Validar email em tempo real
   */
  static async validateEmail(email) {
    try {
      console.log(`🔍 Validando email: ${email}`);
      
      const response = await api.post('/api/register/validate-email', {
        email: email
      });
      
      return {
        success: response.data.success,
        message: response.data.message,
        valid: response.data.valid,
        available: response.data.available
      };
      
    } catch (error) {
      console.error('❌ Erro ao validar email:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao validar email',
        valid: false,
        available: false
      };
    }
  }

  /**
   * ✅ Validar CPF em tempo real
   */
  static async validateCPF(cpf) {
    try {
      console.log(`🔍 Validando CPF: ${cpf}`);
      
      const response = await api.post('/api/register/validate-cpf', {
        cpf: cpf
      });
      
      return {
        success: response.data.success,
        message: response.data.message,
        valid: response.data.valid,
        available: response.data.available
      };
      
    } catch (error) {
      console.error('❌ Erro ao validar CPF:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao validar CPF',
        valid: false,
        available: false
      };
    }
  }
}

export default LicenseService;
